// Dev-host detection. Host starts with "dev-" (dev-dash.taliaz-cm.com) or is localhost.
// Used to gate not-yet-production dashboards (e.g. capacity forecast) to dev only —
// visible in dev (prototype), hidden entirely in prod. (Ohad + Shachar 2026-07-13.)
export function isDevHost(): boolean {
  const h = window.location.hostname;
  return h.startsWith('dev-') || h === 'localhost' || h === '127.0.0.1';
}
